import { css } from "@emotion/react";
import { Colors, Fonts, Spacing } from "@snapchat/snap-design-system";

export const containerPadding = css`
    padding: 2rem;
    font-family: "Avenir Next";
    div:last-child > a {
        text-align: right;
    }
`;

export const stepperLinkStyle = css`
    height: 72px;
    border: 1px solid #dbdde1;
    border-radius: 8px;
    :hover {
        cursor: pointer;
        border-color: ${Colors.Black.V200};
    }
`;

export const previousStyle = css`
    margin-right: ${Spacing.MD}px;
`;

export const linkStyle = css`
    flex-grow: 1;
    padding: ${Spacing.MD}px;
    text-decoration: none;
    color: ${Colors.Black.V200};
    :hover {
        color: ${Colors.Black.V200};
    }
`;

export const stepperText = css`
    ${Fonts.DeprecatedHeading.H300}
    color: ${Colors.Black.V200};
`;
